import { Stack, Tooltip } from "@mui/material";
import { ColorButton } from "./styles";
import PropTypes from "prop-types";

interface ContributeBtnProps {
  onClick: (e: any) => void;
  disabled: boolean;
  toolTipMessage?: string;
}

const ContributeBtn = (props: ContributeBtnProps) => {
  const { onClick, disabled, toolTipMessage } = props;

  return (
    <Stack spacing={2} direction="row">
      <Tooltip
        title={toolTipMessage}
        placement="top-start"
        disableHoverListener={false}
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "1em",
              fontWeight: 500,
            },
          },
        }}
      >
        <span>
          <ColorButton
            onClick={onClick}
            disabled={disabled}
            variant="contained"
            size="small"
          >
            Contribute
          </ColorButton>
        </span>
      </Tooltip>
    </Stack>
  );
};

ContributeBtn.propType = {
  onClick: PropTypes.func,
};

export default ContributeBtn;
